export default {
  banner: {
    title: "Authorization Management",
    subtitle:
      "Authing can help enterprises unify and manage scattered authorization systems automatically, achieving granular authorization policies without extra development costs.",
    img: "authority-banner-img-en.png",
    data1: "Unified scattered permissions",
    data2: "Prevent data leakage",
    data3: "Improve audit efficiency",
    data4: "Reduce self-development costs",
  },
  question: {
    title: "Struggling with in-house development and high costs?",
    card1: {
      title: "Encounter challenges in development",
      item1: {
        title: "Integration difficulty",
        descript:
          "Different authentication protocols in systems hinder the establishment of unified access governance.",
      },
      item2: {
        title: "Incomplete construction",
        descript:
          "Finding experienced individuals for comprehensive permission governance plans is challenging.",
      },
      item3: {
        title: "Complex logic",
        descript:
          "High implementation difficulty due to fine-grained permissions covering multiple resource and subject types.",
      },
      item4: {
        title: "Delayed revocation",
        descript:
          "Manual account management hinders timely permission revocation for employee transitions.",
      },
    },
    card2: {
      title: "Simplify access management with Authing",
      item1: {
        title: "No manual application integration",
        descript:
          "Authing pre-integrates with multiple applications, allowing quick integration without additional development.",
      },
      item2: {
        title: "Proactive permission system construction",
        descript:
          "Authing's experience in building permission management systems for large enterprises ensures highly scalable systems.",
      },
      item3: {
        title: "Flexible adaptation to business needs",
        descript:
          "Customize resources, operations, and subjects in the Authing console to adapt to complex business scenarios.",
      },
      item4: {
        title: "Automated permission assignment/revocation",
        descript:
          "Authing's identity automation platform automatically adjusts permissions, reducing security risks caused by delayed adjustments.",
      },
    },
  },
  model: {
    title: "With Authing, no worries about complex development",
    subtitle:
      "Implements RBAC and ABAC models based on OPA engine, enable more flexible and granular access control.",
    rbac: {
      title: "RBAC",
      subtitle: "Role-based access control",
      img: "authority-rbac-en.jpg",
      item1: {
        title: "What is RBAC?",
        subtitle:
          "RBAC grants permissions to users based on their roles. Roles can be defined as positions, project teams, departments, etc. ",
      },
      item2: {
        title: "For small and medium-sized enterprises",
        subtitle:
          "This scenario is for small and medium enterprises that require a rapidly scalable permission management system.",
      },
      item3: {
        title: "Enable agile permission management",
        subtitle:
          "Customize APIs, menus, buttons, and resource operations with Authing for flexible authorization policies and achieve rapid iterations.",
      },
    },
    abac: {
      title: "ABAC",
      subtitle: "Attribute-based access control",
      img: "authority-abac-en.jpg",
      item1: {
        title: "What is ABAC?",
        subtitle:
          "ABAC applies attributes for dynamic operation allowances, including IP addresses, request sources, access time, etc.",
      },
      item2: {
        title: "For Large organizations",
        subtitle:
          "This scenario is for large organizations that require a fine-grained permission management system.",
      },
      item3: {
        title: "Enhance authorization policies with restrictions",
        subtitle:
          "Enterprises with high security needs can quickly restrict user attributes like IP, request sources, and devices with Authing's ABAC policies.",
      },
    },
  },
  advantage: {
    title: "Establish comprehensive system to meet security needs",
    subtitle:
      "Authing offers powerful modules for enterprises to build precise permission systems and comply with security policies. ",
    item1: {
      title: "Combine pre-integrated apps for unified access control",
      img: "authority-feature1-en.png",
      descript:
        "By integrating apps into the Authing console, enterprises can create roles, resources, and authorizations within the app's permission space without extra integration costs.",
    },
    item2: {
      title: "Customize resources to easily implement granular policies",
      img: "authority-feature2-en.png",
      descript:
        "Authing simplifies this complex permission logic by abstracting resources into strings, trees, and arrays, covering various permission management scenarios. Enterprises can configure them to suit their needs.",
    },
    item3: {
      title: "Create unified views of one's permissions across multiple apps",
      img: "authority-feature3-en.png",
      descript:
        "Authing provides visual and comprehensive user-level permission views, displaying resource permissions and associated policies. Enterprises can generate multiple views through filtering, facilitating post-auditing and reducing repetitive work.",
    },
    item4: {
      title: "Centralize API authentication for secure service calls",
      img: "authority-feature4-en.png",
      descript:
        "Combine Authing's permission management and API gateway for unified and intercepted API authentication in system APIs, microservices, and M2M scenarios. Ensure secure service calls by promptly denying access during business changes. ",
    },
    item5: {
      title: "Automated management reduces inefficiency and operational risks",
      img: "authority-feature5-en-2.png",
      descript:
        "With Authing's automated permission orchestration, employee lifecycle processes are automated during onboarding, offboarding, or organizational changes. This reduces repetitive work and avoids manual errors.",
      data1: "Improved efficiency",
      data2: "Reduced operational costs",
      data3: "Decreased security risks",
      data4: "Customizable workflow flexible",
    },
    item6: {
      title: "Convenient API/SDK, lower permission system costs",
      img: "authority-feature6-en-2.png",
      descript:
        "Authing's backend and API/SDKs shorten development time to 2 weeks, avoiding repetitive development and allowing quick adaptation for future business system additions.",
      data1: "Reduced development costs",
      data2: "Supports business growth",
      data3: "Rapid adaptation to iterations",
      data4: "Can be done in 2 weeks",
    },
  },
};
